import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type AppInfo } from 'types/api'
import { useMutation } from '@tanstack/react-query'

interface UsePutAppInfoProps {
  onSuccess?: (data: boolean, variables: AppInfo) => void | Promise<void>
  onError?: (error: Error, variables: AppInfo) => void
}

export const usePutAppInfo = ({ onSuccess, onError }: UsePutAppInfoProps) => {
  const put = useTypedApiClient({
    path: '/admin/appInfo',
    method: 'put',
  })

  return useMutation<boolean, Error, AppInfo>({
    mutationFn: async (data: AppInfo) => {
      const response = await put({ ...data })
      return response.data
    },
    onSuccess: async (data, variables) => {
      await onSuccess?.(data, variables)
    },
    onError,
  })
}
